module.exports = __webpack_public_path__ + "img/icn_facebook.a960a745.svg";